export default __webpack_public_path__ + "static/empty.png?v=c64259e0354605cefd8b59e719d72ea9";